var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleButton',{attrs:{"flat":"","dense":"","round":"","ripple":false,"aria-label":_vm.$t('navigation.userProfile.settings')}},[_c('Avatar',{attrs:{"accountId":_vm.accountId,"editable":false,"height":"38px","width":"38px","round":"","shouldShowOnlineIndicator":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }